<template>
  <f7-block>
    <f7-row>
      <f7-col width="100">
        <f7-block v-if="!loadedTasks">
          <div class="loadingFalse">
            <div class="preloader" />
          </div>
        </f7-block>
        <f7-block v-else>
          <ListTask />
        </f7-block>
      </f7-col>
    </f7-row>
  </f7-block>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ListTask from '../../searchEngine/listTaskByCompany/index.vue';

export default {
  name: 'Tasks',
  components: {
    ListTask,
  },
  data() {
    return {
      loadedTasks: false,
    };
  },
  computed: {
    ...mapState('Plantation', ['currentPlantation']),
  },
  async beforeMount() {
    try {
      this.setIdPlantationTask(this.currentPlantation.id);
      this.setIdCompanyTask(this.currentPlantation.companyId);
      this.loadedTasks = true;
    } catch (error) {
      this.$f7.dialog.alert(this.$t(`${error}`));
    }
  },
  methods: {
    ...mapActions('TaskByCompany', ['setIdPlantationTask', 'setIdCompanyTask']),
  },
};
</script>

<style lang="scss" scoped>
@import './Tasks.styles.scss';
</style>
